import React from "react";
import "./Results.css";
import Projects from "../../Works/AllWork.json";

const Results = props => {
  return (
    <div className="pb-5 pt-5 results-container-background-color">
      {Projects.map((project, index) => {
        return project.projectId === +props.projectId ? (
          <div>
            <div className="row">
              <div className="px-5 pb-5 col-xs-12 px-xs-5 pb-xs-5 col-sm-12 px-sm-5 pb-sm-5 col-md-10 offset-md-1">
                <div>
                  <div className="results-header-size pb-3">The Results</div>
                </div>
                <ul className="list-group">
                  {project.results.map(result => (
                    <li className="list-group-item list-group-item" data-AOS="flip-up">
                    &#9989;{result}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        ) : null;
      })}
    </div>
  );
};

export default Results;



// WEBPACK FOOTER //
// ./src/components/SingleProject/Results/Results.js